import AddRoundedIcon from '@mui/icons-material/AddRounded';

export default AddRoundedIcon;
